import { api } from "@/services/api";

export interface Visitor {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  dateOfBirth?: string;
  clientId: number;
  clientName: string;
  employeeId?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  gender?: string;
  ssn?: string;
  status: 'ACTIVE' | 'INACTIVE';
  createdAt: string;
  updatedAt: string;
}

export interface VisitorRequest {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  dateOfBirth?: string;
  clientId: number;
  clientName: string;
  employeeId?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  gender?: string;
  ssn?: string;
  status: string;
}

export const visitorApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Super Admin endpoints
    getAllVisitors: builder.query<Visitor[], void>({
      query: () => "/super-admin/visitors",
      providesTags: ["Visitors"],
    }),

    getVisitorById: builder.query<Visitor, number>({
      query: (id) => `/super-admin/visitors/${id}`,
      providesTags: ["Visitors"],
    }),

    createVisitor: builder.mutation<Visitor, VisitorRequest>({
      query: (body) => ({
        url: "/super-admin/visitors",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Visitors"],
    }),

    updateVisitor: builder.mutation<Visitor, { id: number; data: VisitorRequest }>({
      query: ({ id, data }) => ({
        url: `/super-admin/visitors/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Visitors"],
    }),

    deleteVisitor: builder.mutation<void, number>({
      query: (id) => ({
        url: `/super-admin/visitors/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Visitors"],
    }),

    getVisitorsByClientId: builder.query<Visitor[], number>({
      query: (clientId) => `/super-admin/visitors/client/${clientId}`,
      providesTags: ["Visitors"],
    }),

    getVisitorsByStatus: builder.query<Visitor[], string>({
      query: (status) => `/super-admin/visitors/status/${status}`,
      providesTags: ["Visitors"],
    }),
  }),
});

export const {
  useGetAllVisitorsQuery,
  useGetVisitorByIdQuery,
  useCreateVisitorMutation,
  useUpdateVisitorMutation,
  useDeleteVisitorMutation,
  useGetVisitorsByClientIdQuery,
  useGetVisitorsByStatusQuery,
} = visitorApi;
